import { render } from "./Flights.vue?vue&type=template&id=0201550d&scoped=true&ts=true"
import script from "./Flights.vue?vue&type=script&lang=ts"
export * from "./Flights.vue?vue&type=script&lang=ts"

import "./Flights.vue?vue&type=style&index=0&id=0201550d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0201550d"]])

export default __exports__